import { render, staticRenderFns } from "./ModalResource.vue?vue&type=template&id=a293e63e"
import script from "./ModalResource.vue?vue&type=script&lang=ts"
export * from "./ModalResource.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports